import { DocumentPage } from "../components";
import { getPrivacyPolicyData, PrivacyPolicyPage } from "../lib/api";
import { getGlobalStaticProps } from "../lib/helpers";

interface PrivacyPolicyData {
  page: PrivacyPolicyPage;
}

export default function PrivacyPolicy({ data }: { data: PrivacyPolicyData }) {
  const { title, date, contentMdx } = data.page;
  return <DocumentPage title={title} date={date} contentMdx={contentMdx} />;
}

export async function getStaticProps() {
  const page = await getPrivacyPolicyData();
  const data: PrivacyPolicyData = {
    page,
  };
  const props = await getGlobalStaticProps(
    { data },
    {
      pageTitle: page.title,
      pageDescription: page.meta_description,
      publishDate: page.date,
      pageImage: page.image,
    }
  );
  return { props };
}
